import { StaticFilters as Filters, ListFiltersLayout as FiltersLayout, DateTimeRangeFilter } from 'framework/list';
import { TimelineLayout, TimelinePageLayout, Timeline } from 'framework/ui/timeline';
import useCrmActivityItem from 'domain/sales/shared/timeline/activity/crmActivityRegistry';
import useCrmNoteItem from 'domain/sales/shared/timeline/note/crmNoteRegistry';
import { Show } from 'framework/show';
import CrmTimelineEntryTypeFilter from 'domain/sales/shared/timeline/filter/CrmTimelineEntryTypeFilter';
import { useOpportunityId } from 'domain/shared/opportunity';
import useOpportunityService from 'domain/sales/opportunity/opportunityService';
import OpportunityEntityHeader from 'domain/sales/opportunity/shared/OpportunityEntityHeader';
import OpportunityMenu from 'domain/sales/opportunity/shared/OpportunityMenu';
import OpportunityTimelineBreadcrumbs from 'domain/sales/opportunity/Timeline/Breadcrumbs';
import usePresaleRequestItem from 'domain/sales/opportunity/presale/request/presaleRequestRegistry';
import usePresaleOutputItem from 'domain/sales/opportunity/presale/output/presaleOutputRegistry';
import useContractRequestItem from 'domain/sales/opportunity/presale/contract/contractRequestRegistry';
import { TimelineItem, TimelineRegistry } from 'framework/ui/timeline';
import useStrategyNoteItem from '../../shared/timeline/strategyNote/useStrategyNoteItem';

const OpportunityTimelinePage = () => {
  const opportunityId = useOpportunityId();
  const {
    getById,
    searchTimelineItems,
    createTimelineItem,
    getTimelinePageById,
    getFilterValidationSchema,
    pinOpportunitieTimeline,
  } = useOpportunityService();

  const activityRegistry = useCrmActivityItem();
  const noteRegistry = useCrmNoteItem();
  const strategyNoteRegistry = useStrategyNoteItem();
  const presaleRequestRegistry = usePresaleRequestItem();
  const presaleOutputRegistry = usePresaleOutputItem();
  const contractRequestRegistry = useContractRequestItem();
  const registries = [
    noteRegistry,
    strategyNoteRegistry,
    activityRegistry,
    presaleRequestRegistry,
    presaleOutputRegistry,
    contractRequestRegistry,
  ] as unknown as TimelineRegistry[];

  const filters = (
    <Filters getValidationSchema={getFilterValidationSchema}>
      <FiltersLayout>
        <CrmTimelineEntryTypeFilter />
        <DateTimeRangeFilter label="Created date" source="createdAt" />
      </FiltersLayout>
    </Filters>
  );
  return (
    <Show getDataMethod={() => getById(opportunityId)}>
      <Timeline
        registries={registries}
        pinTimelineAction={pinOpportunitieTimeline}
        getDataMethod={request => searchTimelineItems(opportunityId, request)}
        createTimelineItemMethod={(itemType, request) =>
          createTimelineItem(opportunityId, itemType, request) as Promise<TimelineItem>
        }
        getPageByEntryIdMethod={id => getTimelinePageById(opportunityId, id)}
      >
        <TimelinePageLayout
          menu={<OpportunityMenu />}
          breadcrumbs={<OpportunityTimelineBreadcrumbs />}
          entityHeader={<OpportunityEntityHeader />}
          filter={filters}
          titleVariant="h4"
        >
          <TimelineLayout noEntriesMessage="No entries in this opportunity timeline yet." />
        </TimelinePageLayout>
      </Timeline>
    </Show>
  );
};

export default OpportunityTimelinePage;
